module.exports = __webpack_public_path__ + "media/images/bg_questionnaire_mv_sp-06a982cfd592b014848f97684ccc966b.jpg";